function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7849 1.43773V12.7683H12.6264V13.8815H0.583344V12.7683H1.42489V1.43773C1.42572 0.661723 2.04899 0.0328526 2.81809 0.0320129H10.3917C11.1608 0.0329287 11.784 0.661755 11.7849 1.43773ZM9.32025 2.07417H7.3754V4.0365H9.32025V2.07417ZM7.3754 4.71181H9.32025V6.67414H7.3754V4.71181ZM9.32025 7.34946H7.3754V9.31124H9.32025V7.34946ZM3.88998 2.07417H5.83484V4.0365H3.88998V2.07417ZM5.83484 4.71181H3.88998V6.67414H5.83484V4.71181ZM3.88998 7.34946H5.83484V9.31124H3.88998V7.34946ZM5.89472 12.7683H7.31592V12.7626H8.41923V10.2154H4.79142V12.7626H5.89472V12.7683Z",
  fill: "#37517F"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 6.0032,
  y: 11.2641,
  width: 1.35484,
  height: 1.50538,
  fill: "#37517F"
});

const SvgApartOutlined = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgApartOutlined, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Apart-Outlined.ab544ba9.svg";
export { ForwardRef as ReactComponent };